module.exports = __webpack_public_path__ + "static/media/chives.a7ffbfe9.jpg";